import { render, staticRenderFns } from "./event-form-builder.vue?vue&type=template&id=4d4c951a&scoped=true&"
import script from "./event-form-builder.vue?vue&type=script&lang=js&"
export * from "./event-form-builder.vue?vue&type=script&lang=js&"
import style0 from "./event-form-builder.vue?vue&type=style&index=0&id=4d4c951a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c951a",
  null
  
)

export default component.exports